import { graphql, HeadProps } from 'gatsby';
import React, { ReactElement } from 'react';
import AbTestingService from 'atoms/AbTesting/AbTestingService';
import { HeadComponent } from 'atoms/Head/head';
import HomepageView from 'src/app/views/homepage';
import { DefaultStaticSEOPageProps } from 'src/types/pages';

const IndexPage = (props: DefaultStaticSEOPageProps): ReactElement => {
  return AbTestingService<DefaultStaticSEOPageProps['data'], unknown>({
    props,
    control: {
      data: props.data,
      template: HomepageView,
    },
  });
};

export default IndexPage;

export const Head = (props: HeadProps<DefaultStaticSEOPageProps['data']>): JSX.Element => {
  const helmet = {
    title: 'Mighty Networks | Community Platform, Courses & Memberships',
    description:
      "The MOST $1M communities created. Ranked #1 community platform on G2 because of Mighty's 'people magic.'",
    previewImageURL: props.data.seoImage.file.url,
  };

  return (
    <HeadComponent
      helmet={helmet}
      location={props.location}
    />
  );
};

export const pageQuery = graphql`
  query LandingPageQuery {
    seoImage: contentfulAsset(contentful_id: { eq: "3Oe871ww60CDt3yYp4ULpd" }) {
      file {
        url
      }
    }
  }
`;
